import ProjectClaimsSidebarWidgetModule from './sidebar-widget.module'

export default ProjectClaimsSidebarWidgetModule
